import React from 'react';
import AddClientForm, { AddClientFormValues } from '../forms/AddClientForm';

interface IAddClientProps {
  isActive: boolean;
  onSubmit: (values: AddClientFormValues) => Promise<void>;
}

const AddClient: React.FC<IAddClientProps> = props => {
  return <AddClientForm isActive={props.isActive} onSubmit={props.onSubmit} submitButtonText="Add Client" />;
};

export default AddClient;
